/* unplugin-vue-components disabled */import { render } from "./PunishPage.vue?vue&type=template&id=f6d4f3e8&scoped=true"
import script from "./PunishPage.vue?vue&type=script&lang=js"
export * from "./PunishPage.vue?vue&type=script&lang=js"

import "./PunishPage.vue?vue&type=style&index=0&id=f6d4f3e8&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6d4f3e8"]])

export default __exports__